import { render, staticRenderFns } from "./ShopPlatformSpus.vue?vue&type=template&id=7f666c60&scoped=true"
import script from "./ShopPlatformSpus.vue?vue&type=script&lang=ts"
export * from "./ShopPlatformSpus.vue?vue&type=script&lang=ts"
import style0 from "./ShopPlatformSpus.vue?vue&type=style&index=0&id=7f666c60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f666c60",
  null
  
)

export default component.exports